import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConfigurationService {

  private Environment: 'Local' | 'Production' | 'Stage' = 'Production'; // Production, Stage, Local

  private EnvironmentObject = {
    Local: {
      apiUrl: 'http://localhost:3040'
    },
    Stage: {
      apiUrl: location.origin
    },
    Production: {
      apiUrl: "https://bookbridge.co.in"
    }
  };

  get apiBaseUrl(): string {
    return this.EnvironmentObject[this.Environment].apiUrl;
  }
}
